import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["checkedChildren", "unCheckedChildren", "onChangeHandler", "size", "className", "clsPrefix", "disabled", "loading", "colors", "enterKeyDown"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-switch.
* homepage: https://github.com/react-component/switch
*/
import React, { Component } from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import PropTypes from "prop-types";
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  clsPrefix: PropTypes.string,
  disabled: PropTypes.bool,
  checkedChildren: PropTypes.any,
  unCheckedChildren: PropTypes.any,
  onChangeHandler: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  enterKeyDown: PropTypes.bool,
  //是否启用 enter 和 space 键
  loading: PropTypes.bool,
  autoFocus: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'small', 'default'])
};
var defaultProps = {
  checkedChildren: null,
  unCheckedChildren: null,
  defaultChecked: false,
  size: "sm",
  disabled: false,
  onChangeHandler: function onChangeHandler() {},
  onChange: function onChange() {},
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  enterKeyDown: true,
  loading: false,
  autoFocus: false
};
var sizeMap = {
  sm: 'sm',
  lg: 'lg',
  small: '',
  default: 'sm'
};
var Switch = (_dec = WebUI({
  name: "switch",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Switch, _Component);

  var _super = _createSuper(Switch);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setChecked", function (checked, e) {
      if (_this.props.disabled || _this.props.loading) {
        return;
      }

      if (!('checked' in _this.props)) {
        _this.setState({
          checked: checked
        });
      }

      _this.props.onChangeHandler(checked);

      _this.props.onChange(checked, e);
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.props.disabled || _this.props.loading) {
        return;
      }

      var checked = !_this.state.checked;

      _this.setChecked(checked, e);

      _this.props.onClick && _this.props.onClick(checked, e); //支持onClick事件
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e, enterKeyDown) {
      if (e.keyCode === 37) {
        // Left
        _this.setChecked(false, e);
      } else if (e.keyCode === 39) {
        // Right
        _this.setChecked(true, e);
      } else if (e.keyCode === 32 || e.keyCode === 13) {
        // Space, Enter
        if (enterKeyDown) {
          e.preventDefault(); // 阻止Space, Enter默认触发点击事件

          _this.clickHandler(e);
        }
      }

      _this.props.onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function (e) {
      if (_this.node) {
        _this.node.blur();
      }

      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveNode", function (node) {
      _this.node = node;
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      if (_this.node) {
        _this.node.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      if (_this.node) {
        _this.node.blur();
      }
    });

    var _checked = false;

    if ('checked' in props) {
      _checked = !!props.checked;
    } else if ('defaultValue' in props) {
      _checked = !!props.defaultValue;
    } else {
      _checked = !!props.defaultChecked;
    }

    _this.state = {
      checked: _checked
    };
    return _this;
  }

  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          checkedChildren = _this$props.checkedChildren,
          unCheckedChildren = _this$props.unCheckedChildren,
          onChangeHandler = _this$props.onChangeHandler,
          size = _this$props.size,
          className = _this$props.className,
          clsPrefix = _this$props.clsPrefix,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          colors = _this$props.colors,
          enterKeyDown = _this$props.enterKeyDown,
          others = _objectWithoutProperties(_this$props, _excluded); //获取checked


      var checked = this.state.checked;
      var classes = {
        "is-checked": checked
      };

      if (sizeMap[size]) {
        classes["".concat(clsPrefix, "-").concat(sizeMap[size])] = true;
      }

      if (colors) {
        classes["".concat(clsPrefix, "-").concat(colors)] = true;
      }

      classes[["".concat(clsPrefix, "-disabled")]] = disabled;

      if (loading) {
        classes[["".concat(clsPrefix, "-loading")]] = loading;
        classes[["".concat(clsPrefix, "-disabled")]] = loading;
      }

      var classNames = classnames(clsPrefix, classes);
      return /*#__PURE__*/React.createElement("span", {
        className: disabled && checked ? "".concat(clsPrefix, "-backdrop ").concat(clsPrefix, "-span") : "".concat(clsPrefix, "-span")
      }, /*#__PURE__*/React.createElement("button", _extends({}, others, {
        ref: this.saveNode,
        onClick: this.clickHandler,
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyDown(e, enterKeyDown);
        },
        onMouseUp: this.handleMouseUp,
        className: classnames(className, classNames),
        tabIndex: disabled ? -1 : 0
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-inner")
      }, checked ? checkedChildren : unCheckedChildren)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if ("checked" in nextProps) {
        //return{ checked: !!nextProps.checked };
        newState.checked = !!nextProps.checked;
      }

      return newState;
    }
  }]);

  return Switch;
}(Component)) || _class);
Switch.propTypes = propTypes;
export default Switch;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-switch/src/Switch.js